import React, { useEffect } from 'react';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const baseClasses = 'fixed md:top-20 md:right-6 bottom-20 md:bottom-auto inset-x-0 md:inset-x-auto mx-4 md:mx-0 px-6 py-3 rounded-lg shadow-2xl drop-shadow-2xl transform transition-all duration-500 z-50';
  const typeClasses = {
    success: 'bg-green-700 text-white',
    error: 'bg-red-700 text-white',
    warning: 'bg-yellow-700 text-white',
    info: 'bg-blue-700 text-white'
  };

  const ariaRole = type === 'error' || type === 'warning' ? 'alert' : undefined;
  const ariaLive = type === 'error' || type === 'warning' ? undefined : 'polite';

  return (
    <div className={`${baseClasses} ${typeClasses[type]} animate-fade-in`} role={ariaRole} aria-live={ariaLive} aria-atomic="true">
      <div className="flex items-center">
        <span className="mr-2 font-bold">
          {type === 'success' && '✓'}
          {type === 'error' && '✕'}
          {type === 'warning' && '⚠'}
          {type === 'info' && 'ℹ'}
        </span>
        <p className="text-sm font-bold">{message}</p>
      </div>
    </div>
  );
};

export default Toast;
